import styled from 'styled-components';
import { rem } from 'polished';

import Modal from '../../core/Modal';
import Input from '../../core/Input';

const StyledModal = styled(Modal)`
  text-align: center;
`;

const StyledInput = styled(Input)`
  max-width: ${rem('260px')};
  margin: ${rem('20px')} auto ${rem('30px')} auto;
  display: block;
`;
const StyledDniInfo = styled.p`
  color: red;
  font-weight: bold;
`;

export { StyledModal, StyledInput, StyledDniInfo };
